import { initReactI18next } from "react-i18next";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import dutchContent from "./content/dutch.json";
import englishContent from "./content/english.json";
import frenchContent from "./content/french.json";
import germanContent from "./content/german.json";
import greekContent from "./content/greek.json";
import italianContent from "./content/italian.json";
import spanishContent from "./content/spanish.json";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: englishContent,
      },
      gr: {
        translation: greekContent,
      },
      de: {
        translation: germanContent,
      },
      nl: {
        translation: dutchContent,
      },
      fr: {
        translation: frenchContent,
      },
      es: {
        translation: spanishContent,
      },
      it: {
        translation: italianContent,
      },
    },
  });

export default i18n;
